import { Culture } from '../../types';

export const hualapai: Culture = {
  name: 'Hualapai',
  languageFamily: 'Yuman-Cochimí',
  terms: [
    {
      word: 'Hualapai',
      phonetic: 'wah-lah-pie',
      description: 'Meaning "people of the tall pines," this is the name of the tribe and language.'
    },
    {
      word: 'Hunyah',
      phonetic: 'hoo-nyah',
      description: 'Hualapai word for "sun."'
    },
    {
      word: 'Matavi',
      phonetic: 'mah-tah-vee',
      description: 'Hualapai word for "water."'
    },
    {
      word: 'Nyava',
      phonetic: 'nyah-vah',
      description: 'Hualapai word for "talk" or "speech."'
    },
    {
      word: 'Wiha',
      phonetic: 'wee-hah',
      description: 'Hualapai word meaning "no" or "negative."'
    }
  ]
};